import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";

import { useScreen, useFaces, useFaceOrg, useRouter } from "hooks";
import MakePresenter from "presenters/MakePresenter";
import MakeMessagePresenter from "presenters/MakeMessagePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import CVPModal from "components/CVPModal";
import { appRoutes } from "routes";
import { FACE_PAGE_FLOWS, ENTRY_POINTS } from "enums";

import useStyles from "./useStyles";

const Actions = (props) => {
  const classes = useStyles();
  const { isMobile } = useScreen();
  const { orphanFaces, setMode, setFacesToAddPerson } = useFaces();
  const { setEntryPoint } = useFaceOrg();
  const { push, pushWithSave } = useRouter();
  const {
    make,
    isOwner,
    templateGroup,
    isAddInfoVisible,
    isCVPModalVisible,
    setCVPModalVisible,
    onAddMessageButtonClick,
    onShareButtonClick,
  } = props;

  const makeMessage = MakePresenter.makeMessage(make);
  const isMakeMessageExists = !R.isNil(makeMessage);
  const isMessageEmpty = R.isEmpty(MakeMessagePresenter.message(makeMessage));
  const templateGroupId = TemplateGroupPresenter.id(templateGroup);

  const { castings } = make;

  const castingIds = castings.map((casting) => casting.headId);
  const castingOrphanFaces = orphanFaces.filter((face) => castingIds.includes(face.id));

  const handleCVPModalOpen = () => setCVPModalVisible(true);
  const handleCVPModalClose = () => setCVPModalVisible(false);

  const handleAddInfo = () => (R.isEmpty(castingOrphanFaces) ? push(appRoutes.peoplePath()) : handleCVPModalOpen());

  const handleGoToFacePage = () => {
    setFacesToAddPerson(castingOrphanFaces);
    setMode(FACE_PAGE_FLOWS.ORPHAN_FACES);
    setEntryPoint(ENTRY_POINTS.SHARE);
    pushWithSave(appRoutes.facePath());
  };
  const handleGoToPeoplePage = () => push(appRoutes.peoplePath());

  const renderActions = () => (
    <div className={classes.action}>
      <Button
        component={NavLink}
        to={MakePresenter.notOwnerButtonPath(make, templateGroupId)}
        size={isMobile ? "medium" : "large"}
        variant="outlined"
        color="primary"
      >
        {MakePresenter.notOwnerButtonText(make)}
      </Button>
    </div>
  );

  const renderOwnerActions = () => (
    <>
      <div className={classes.action}>
        <Button
          id="make-share"
          onClick={onShareButtonClick}
          size={isMobile ? "medium" : "large"}
          variant="contained"
          color="primary"
        >
          SHARE
        </Button>
      </div>
      {(!isMakeMessageExists || isMessageEmpty) && (
        <div className={classes.action}>
          <Button
            id="make-add-message"
            onClick={onAddMessageButtonClick}
            size={isMobile ? "medium" : "large"}
            variant="outlined"
            color="primary"
          >
            ADD A MESSAGE
          </Button>
        </div>
      )}
      {isAddInfoVisible && (
        <Button className={classes.action} onClick={handleAddInfo}>
          Add info to faces!
        </Button>
      )}
      {isCVPModalVisible && !R.isEmpty(castingOrphanFaces) && (
        <CVPModal
          castingOrphanFaces={castingOrphanFaces}
          onClose={handleCVPModalClose}
          handleGoToFacePage={handleGoToFacePage}
          handleGoToPeoplePage={handleGoToPeoplePage}
        />
      )}
    </>
  );

  return (
    <div data-testid="actions-container" className={classes.actions}>
      {isOwner ? renderOwnerActions() : renderActions()}
    </div>
  );
};

Actions.propTypes = {
  make: MakePresenter.shape().isRequired,
  templateGroup: TemplateGroupPresenter.shape().isRequired,
  isOwner: PropTypes.bool.isRequired,
  isAddInfoVisible: PropTypes.bool.isRequired,
  isCVPModalVisible: PropTypes.bool.isRequired,
  setCVPModalVisible: PropTypes.func.isRequired,
  onShareButtonClick: PropTypes.func.isRequired,
  onAddMessageButtonClick: PropTypes.func.isRequired,
};

export default Actions;
